import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from 'talkr';
import steps from '../../survey/steps';
import store from '../../store';
import s from './index.module.scss';

const BOTTOM_BAR_FULL_WIDTH_STEPS = new Set([
  'customV1_startPage',
  'customV2_startPage',
  'customV2_policyPage',
  'customV2_policyPageV2',
  'customV2_policyPageV3',
  'customV2_policyPageV4',
  'customV2_policyPageV5',
  'customV2_videoPolicyPage',
  'customV2_startPageV2',
  'customV2_startPageV3',
  'customV2_startPageV4',
  'customV2_startPageV5',
  'customV2_startPageV6',
  'customV2_startPageV7',
  'customV2_startPageV8',
  'customV2_startPageV11',
  'customV2_startPageV12',
  'customV2_startPageV13',
  'customV2_startPageV17',
  'customV2_startPageV18',
  'customV2_startPageV19',
  'customV2_startPageV20',
  'customV2_startPageV21',
  'customV2_startPageV22',
  'customV2_startPageV23',
  'customV2_startPageV24',
  'customV2_startPageV25',
  'customV2_startPageV26',
  'customV2_startPageV27',
  'customV2_startPageV28',
  'customV2_startPageV29',
  'customV2_startPageV30',
  'customV2_startPageV31',
]);

function ActionBar({ 
  show, 
  currentStepCompleted, 
  transparentBg, 
  whiteStyle,
  withShadow,
  v2,
}) {
  const { T } = useT();
  const dispatch = useDispatch();
  const stateClass = show ? s.show : '';
  const transparentBgClass = transparentBg ? s.transparentBg : '';
  const isFirstStep = store.getState().steps.currentStepIndex === 0;
  const isStepRole = store.getState().steps.currentStep === 'role';
  const whiteStyleClass = whiteStyle ? s.whiteStyle : '';
  const withShadowClass = withShadow ? s.withShadow : '';
  const withV2Class = v2 ? s.v2 : '';
  const { currentStep } = store.getState().steps;
  const bottomBar = BOTTOM_BAR_FULL_WIDTH_STEPS.has(currentStep)
    ? s.fullWidth
    : 'bottomBar';

  const actionBarRef = useRef(null);

  useEffect(() => {
    if ((currentStep === 'customV2_policyPage' || currentStep === 'customV2_policyPageV2' || currentStep === 'customV2_videoPolicyPage' || currentStep === 'customV2_policyPageV3' || currentStep === 'customV2_policyPageV4') && actionBarRef) {
      actionBarRef.current.style.top = 'auto';
    }
  }, [currentStep]);

  useEffect(() => {
    isStepRole && dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: false,
    });
  });

  function forward() {
    if (!currentStepCompleted) return;

    !isStepRole && steps.navigate.forward({
      preventAction: 500,
    });

    steps.userMovedToNextStepByClick({ byNextStep: false });
  }

  return (
    <div className={`${s.actionBar} ${stateClass} ${transparentBgClass} ${whiteStyleClass} ${withShadowClass} ${bottomBar} ${withV2Class}`} ref={actionBarRef}>
      <button
        className={s.completeButton}
        type="button"
        onClick={forward}
        onTouchStart={forward}
        disabled={!currentStepCompleted}
      >
        {T(isFirstStep ? 'get_started' : 'continue')}
      </button>
    </div>
  );
}

export default ActionBar;
